import { userService } from '../misc/user.service'
import router from '../router'
const { v1: uuidv1 } = require('uuid')
const ObjectID = require("bson-objectid")


const localUser = JSON.parse(localStorage.getItem('user'))

function updateStorage(data) {
    const lUser = JSON.parse(localStorage.getItem('user')) || {}

    localStorage.setItem('user', JSON.stringify(Object.assign(lUser, data)))
}

const state = {
    name: localUser ? localUser.name : uuidv1(),
    status: localUser ? localUser.status : 'loggedOut',
    ghost: localUser ? localUser.ghost : true,
    id: localUser && localUser.id ? localUser.id : new ObjectID(),
}

updateStorage(state)

const actions = {
    login({ dispatch, commit }, { username, password, next }) {
        commit('loginRequest', { username })
    
        return userService.login(username, password)
            .then(
                user => {
                    commit('loginSuccess', user.user)
                    router.push(next ? next : '/')
                    return true
                },
                error => {
                    commit('loginFailure', error)
                    return false
                }
            )
    },
    logout({ commit }) {
        //userService.logout()
        commit('logout')
    },
}


const mutations = {
    loginRequest(state, user) {
        state.status = 'loggingIn'
    },
    loginSuccess(state, user) {
        state.status = 'loggedIn'
    },
    loginFailure(state) {
        state.status = 'loggedOut'
        if (!state.ghost) {
            state.name = uuidv1()
            state.id = new ObjectID()
        }
        updateStorage(Object.assign(state, {token: null}))
    },
    logout(state) {
        state.status = 'loggedOut'
        if (!state.ghost) {
            state.name = uuidv1()
            state.id = new ObjectID()
        }
        updateStorage(Object.assign(state, {token: null}))
    },
}


export const user = {
    namespaced: true,
    state,
    actions,
    mutations
}